/**
 *  Determine if running on the server or browser
 *
 *  @returns {boolean} - Returns true when running on the server and false in a browser
 */
 function isServer() {
    return typeof window === 'undefined';
}

/**
 *  Getter for window
 *
 *  @returns {object} - Returns the window object
 */
 function getWindow() {
    if(isServer()) {
        return {};
    }
    return window;
}

export {
    getWindow,
    isServer,
};